export default {
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  user: state => state.user,
  users: state => state.users,
  totalUsers: state => state.totalUsers,
  currentUser: state => state.currentUser,
  highlight: state => state.highlight,
  highlightPassword: state => state.highlightPassword,
  source: state => state.source
}



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js